import { Vector3 } from 'babylonjs';

interface Vec3Data {
    x: number;
    y: number;
    z: number;
}

export function fromObject(obj: Vec3Data) {
    return new Vec3(obj.x, obj.y, obj.z);
}

class Vec3 {

    x: number;
    y: number;
    z: number;

  constructor(x: number, y: number, z: number) {
      this.x = x;
      this.y = y;
      this.z = z;
  }

  add(v: Vec3) {
      return new Vec3(this.x + v.x, this.y + v.y, this.z + v.z);
  }

  sub(v: Vec3) {
      return new Vec3(this.x - v.x, this.y - v.y, this.z - v.z);
  }

  scale(s: number) {
      return new Vec3(this.x * s, this.y * s, this.z * s);
  }

  dot(v: Vec3) {
      return this.x * v.x + this.y * v.y + this.z * v.z;
  }

  norm2() {
      return this.x * this.x + this.y * this.y + this.z * this.z;
  }

  norm() {
      return Math.sqrt(this.norm2());
  }

  normalize() {
      const length = this.norm();
      if(length > 0) {
        return this.scale(1.0 / length);
      }
      return new Vec3(0, 0, 0);
  }

  toBabylonVector3() {
      return new Vector3(this.x, this.y, this.z);
  }

  clone() {
    return new Vec3(this.x, this.y, this.z);
  }
}

export default Vec3;
